import { render } from "./GroupSelectionListView.vue?vue&type=template&id=a7f12886&scoped=true&ts=true"
import script from "./GroupSelectionListView.vue?vue&type=script&lang=ts"
export * from "./GroupSelectionListView.vue?vue&type=script&lang=ts"

import "./GroupSelectionListView.vue?vue&type=style&index=0&id=a7f12886&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f12886"]])

export default __exports__